import { render } from "./DicomTagPopup.vue?vue&type=template&id=dfb281e0&scoped=true&ts=true"
import script from "./DicomTagPopup.vue?vue&type=script&lang=ts"
export * from "./DicomTagPopup.vue?vue&type=script&lang=ts"

import "./DicomTagPopup.vue?vue&type=style&index=0&id=dfb281e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb281e0"]])

export default __exports__